// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__RKzdi","section__content":"styles_section__content__Vn2qE","fadeInOut":"styles_fadeInOut__QEL9q","loader":"styles_loader__v9pEC"};